import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchGroups(searchString) {
  return retryRequest(() =>
    apiRequest(`/groups${searchString ? `?${searchString}` : ``}`),
  );
}

export async function saveGroup(group) {
  return retryRequest(() =>
    apiRequest("/group/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(group),
    }),
  );
}

export async function editGroup(group) {
  return retryRequest(() =>
    apiRequest(`/group/edit/${group.groupCode}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(group),
    }),
  );
}

export async function deleteGroup(group) {
  return retryRequest(() =>
    apiRequest(`/group/delete/${group.groupCode}`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
    }),
  );
}
